<!-- Loading State with Shimmer -->
@if (isLoading() && !hasError()) {
  <!-- <app-document-loader
    message="Loading video..."
    [variant]="ShimmerVariant.Card"
    loaderId="video-loader"
  /> -->

        <div class="loader-overlay">
      <optima-progress-indicator
        [view]="ProcessProgressView.Shimmer"
        [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
          { width: '100%', height: '100%' }
        ] } }">
      </optima-progress-indicator>
    </div>
}

<!-- Error State -->
@if (hasError()) {
  <div class="error-state">
    <div class="error-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
    </div>
    <h2>Failed to Load Video</h2>
    <p class="error-message">{{ errorMessage() }}</p>
    <div class="error-actions">
      <button class="retry-btn" (click)="retryLoad()">Retry</button>
      <button class="back-btn" (click)="goBack()">Back to Libraries</button>
    </div>
  </div>
}

<!-- Video Player -->
@if (!hasError() && videoUrl() && !isLoading()) {
  <!-- <div class="video-container"> -->
    <video
      height="100%"
      width="100%"
      [src]="videoUrl()!"
      controls
      autoplay
      preload="metadata"
      controlsList="nodownload">
      Your browser doesn't support HTML5 video.
      <a [href]="videoUrl()!" class="download-link">Download the video</a> instead.
    </video>
  <!-- </div> -->
}